/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Classification_FailedInputs */

const en_doc_classification_failed = /** @type {(inputs: Doc_Classification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document classification failed`)
};

const pt_br2_doc_classification_failed = /** @type {(inputs: Doc_Classification_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na classificação do documento`)
};

/**
* | output |
* | --- |
* | "Document classification failed" |
*
* @param {Doc_Classification_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_classification_failed = /** @type {((inputs?: Doc_Classification_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Classification_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_classification_failed(inputs)
	return pt_br2_doc_classification_failed(inputs)
});